/** 权益类别 */ var enums_RightBundle = /*#__PURE__*/ function(RightBundle) {
    RightBundle["FREE"] = "FREE";
    RightBundle["LITE"] = "LITE";
    RightBundle["STARTER"] = "STARTER";
    RightBundle["BASIC"] = "BASIC";
    RightBundle["PRO"] = "PRO";
    RightBundle["PREMIUM"] = "PREMIUM";
    return RightBundle;
}({});
/** 账单周期 */ var enums_EBillInterval = /*#__PURE__*/ function(EBillInterval) {
    EBillInterval["Month"] = "Mo";
    EBillInterval["Year"] = "Yr";
    return EBillInterval;
}({});
/** 账单周期数 */ var enums_EBillIntervalCount = /*#__PURE__*/ function(EBillIntervalCount) {
    EBillIntervalCount[EBillIntervalCount["One"] = 1] = "One";
    EBillIntervalCount[EBillIntervalCount["Two"] = 2] = "Two";
    EBillIntervalCount[EBillIntervalCount["Three"] = 3] = "Three";
    return EBillIntervalCount;
}({});
/** 支付渠道 */ var enums_ProductChannel = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(ProductChannel) {
    ProductChannel["Stripe"] = "stripe";
    ProductChannel["Js"] = "js";
    ProductChannel["StripeV2"] = "stripeV2";
    return ProductChannel;
}({})));
/** 订阅场景 */ var enums_TbillReason = /*#__PURE__*/ function(TbillReason) {
    TbillReason["CREATE"] = "create";
    TbillReason["UPGRADE"] = "upgrade";
    TbillReason["CYCLE"] = "cycle";
    return TbillReason;
}({});
/** 权限检查类型 */ var enums_PermissionCheckType = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(PermissionCheckType) {
    PermissionCheckType["PUBLISH_WEBSITE_NUM"] = "PUBLISH_WEBSITE_NUM";
    PermissionCheckType["GOOGLE_ANALYZE"] = "GOOGLE_ANALYZE";
    return PermissionCheckType;
}({})));
/** 按钮文本 */ var enums_TextRes = /*#__PURE__*/ function(TextRes) {
    TextRes["GESTALT"] = "Price_CardButton_GetStarted";
    TextRes["UPGRADE"] = "Price_CardButton_Upgrade";
    TextRes["UPGRADE_PLAN"] = "Price_CardButton_UpgradePlan";
    TextRes["ENJOY"] = "Price_CardButton_Enjoy";
    TextRes["FREE"] = "Price_CardButton_FreePlan";
    TextRes["STARTER"] = "Price_CardButton_StarterPlan";
    TextRes["BASIC"] = "Price_CardButton_BasicPlan";
    TextRes["LITE"] = "Price_CardButton_LitePlan";
    TextRes["PRO"] = "Price_CardButton_ProPlan";
    TextRes["PREMIUM"] = "Price_CardButton_PremiumPlan";
    TextRes["PRICE_BUTTON_SELECT"] = "Price_Button_Select";
    return TextRes;
}({});
/** 用户订阅更新状态 */ var enums_UpdateUserSubscriptionStatus = /*#__PURE__*/ function(UpdateUserSubscriptionStatus) {
    UpdateUserSubscriptionStatus["SUCCESS"] = "success";
    UpdateUserSubscriptionStatus["TIMEOUT"] = "timeout";
    UpdateUserSubscriptionStatus["ERROR"] = "error";
    return UpdateUserSubscriptionStatus;
}({});

const CREDIT_OPTIONS = [
    1000,
    2000,
    3000,
    4000,
    5000
];
const ACTIVE_PROMOTION_CONFIG = {
    fallbackCode: 'BTS15',
    header: {
        height: 490,
        heroImageUrl: 'https://cdn.wegic.ai/wegic-asset-store/img/aug-promo-pricing-banner 2.png',
        liveLabel: '🔥 Live Now • 1,000 Joined',
        creditThreshold: 1000,
        copyKeys: {
            badge: 'Pay_Modal_ActivePromotion_HeaderTitle',
            prefix: 'Pay_Modal_ActivePromotion_Get',
            discount: 'Pay_Modal_ActivePromotion_Discount',
            plans: 'Pay_Modal_ActivePromotion_PlansOrUpgrades',
            credits: 'Pay_Modal_ActivePromotion_Credits',
            codePrefix: 'Pay_Modal_ActivePromotion_WithCode',
            supporting: 'Pay_Modal_ActivePromotion_Supporting',
            days: 'Pay_Modal_ActivePromotion_Days',
            hours: 'Pay_Modal_ActivePromotion_Hours',
            minutes: 'Pay_Modal_ActivePromotion_Minutes',
            seconds: 'Pay_Modal_ActivePromotion_Seconds',
            planTitle: 'Pay_Modal_ActivePromotion_PlanTitle'
        },
        typography: {
            badge: {
                color: '#FFF',
                fontFamily: '"PlusJakartaSans", "Plus Jakarta Sans", Inter, sans-serif',
                fontSize: '12px',
                fontStyle: 'italic',
                fontWeight: 700,
                lineHeight: '15px'
            },
            headline: {
                color: '#FFF',
                fontFamily: 'FugazOne, Inter, sans-serif',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '44px',
                letterSpacing: '0'
            },
            supporting: {
                color: '#FFF',
                fontFamily: 'Inter, sans-serif',
                fontSize: '14px',
                fontStyle: 'italic',
                fontWeight: 400,
                lineHeight: '18px',
                opacity: 0.9
            }
        }
    },
    checkout: {
        couponType: 'ACTIVE_PROMOTION',
        copyKeys: {
            title: 'Pay_Modal_CheckoutCoupon_ActivePromotionTitle',
            subtitle: 'Pay_Modal_CheckoutCoupon_ActivePromotionSubtitle',
            notice: 'Pay_Modal_CheckoutCoupon_ActivePromotionNotice'
        }
    },
    payCard: {
        themes: {
            standardPaid: {
                accentColor: '#016AFE',
                textColor: '#fff'
            },
            premium: {
                accentColor: '#7A5AF8',
                textColor: '#fff'
            },
            fallback: {
                accentColor: '#016AFE',
                textColor: '#fff'
            },
            partnerStackStandardPaid: {
                accentColor: '#3354FF',
                textColor: '#fff'
            },
            partnerStackPremium: {
                accentColor: '#7A5AF8',
                textColor: '#fff'
            }
        }
    },
    creditPurchase: {
        options: CREDIT_OPTIONS,
        slider: {
            min: CREDIT_OPTIONS[0],
            max: CREDIT_OPTIONS[CREDIT_OPTIONS.length - 1],
            step: 1000
        },
        theme: {
            modalBackground: '#3287FF',
            couponBackground: '#88FF00',
            applyButtonBackground: '#000',
            sliderBackground: '#3287FF'
        }
    }
};



const MINUTE_MS = 60000;
const SECOND_MS = 1000;
const DAY_MS = 24 * 60 * 60 * 1000;
const PREMIUM_PLAN_BUNDLES = new Set([
    enums_RightBundle.PRO,
    enums_RightBundle.PREMIUM
]);
const STANDARD_PAID_PLAN_BUNDLES = new Set([
    enums_RightBundle.STARTER,
    enums_RightBundle.BASIC,
    enums_RightBundle.LITE
]);
function isActiveDiscountActivity(activity) {
    return !!activity?.code;
}
function getActivePromotionCode(activity) {
    return activity?.code || ACTIVE_PROMOTION_CONFIG.fallbackCode;
}
function getDiscountActivityRate(activity) {
    if (!activity) {
        return 0;
    }
    let discount = Number(activity.discount);
    if (!Number.isFinite(discount)) {
        return 0;
    }
    if (discount > 1) {
        discount /= 100;
    }
    return Math.min(Math.max(discount, 0), 0.95);
}
function getActivePromotionRemainingMs(options) {
    const end = new Date(options.endTime || '').getTime();
    const now = options.now ?? Date.now();
    return Number.isNaN(end) ? 0 : Math.max(0, end - now);
}
function getActivePromotionCountdown(options) {
    const remainingMs = getActivePromotionRemainingMs(options);
    const isWithinFinalDay = remainingMs < DAY_MS;
    const totalSeconds = Math.floor(remainingMs / SECOND_MS);
    const totalMinutes = Math.floor(totalSeconds / 60);
    const days = Math.floor(totalMinutes / 1440);
    const hours = isWithinFinalDay ? Math.floor(totalSeconds / 3600) : Math.floor(totalMinutes % 1440 / 60);
    return {
        isWithinFinalDay,
        days: String(days).padStart(2, '0'),
        hours: String(hours).padStart(2, '0'),
        minutes: String(totalMinutes % 60).padStart(2, '0'),
        seconds: String(totalSeconds % 60).padStart(2, '0')
    };
}
function getActivePromotionCountdownRefreshDelay(options) {
    const remainingMs = getActivePromotionRemainingMs(options);
    if (remainingMs <= 0) {
        return 0;
    }
    const tickMs = remainingMs < DAY_MS ? SECOND_MS : MINUTE_MS;
    if (remainingMs <= tickMs) {
        return remainingMs;
    }
    return remainingMs % tickMs + 1;
}
function formatActivePromotionEndDate(expiresAtMs, locale) {
    return new Intl.DateTimeFormat(locale, {
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC'
    }).format(expiresAtMs);
}
function getActivePromotionPayCardTheme(type) {
    if (PREMIUM_PLAN_BUNDLES.has(type)) {
        return ACTIVE_PROMOTION_CONFIG.payCard.themes.premium;
    }
    if (STANDARD_PAID_PLAN_BUNDLES.has(type)) {
        return ACTIVE_PROMOTION_CONFIG.payCard.themes.standardPaid;
    }
    return ACTIVE_PROMOTION_CONFIG.payCard.themes.fallback;
}
function getPartnerStackPayCardTheme(type) {
    if (PREMIUM_PLAN_BUNDLES.has(type)) {
        return ACTIVE_PROMOTION_CONFIG.payCard.themes.partnerStackPremium;
    }
    return ACTIVE_PROMOTION_CONFIG.payCard.themes.partnerStackStandardPaid;
}
function getActivePromotionStyleVariables() {
    const { theme } = ACTIVE_PROMOTION_CONFIG.creditPurchase;
    return {
        '--credit-purchase-promotion-modal-background': theme.modalBackground,
        '--credit-purchase-promotion-coupon-background': theme.couponBackground,
        '--credit-purchase-promotion-apply-button-background': theme.applyButtonBackground,
        '--credit-purchase-promotion-slider-background': theme.sliderBackground
    };
}

export { ACTIVE_PROMOTION_CONFIG, enums_EBillInterval as EBillInterval, enums_RightBundle as RightBundle, enums_TbillReason as TbillReason, formatActivePromotionEndDate, getActivePromotionCode, getActivePromotionCountdown, getActivePromotionCountdownRefreshDelay, getActivePromotionPayCardTheme, getActivePromotionStyleVariables, getDiscountActivityRate, getPartnerStackPayCardTheme, isActiveDiscountActivity };
